export enum ProductTemplateProviderType {
  None = 0,
  Nobb = 1,
  Grunndata = 2,
  Heidenreich = 3,
  Ahlsell = 4,
  BerggardAmundsen = 5,
  Logiq = 6,
  Solar = 7,
}
